import * as Nullable from '../Data/Nullable'

export interface Country {
    code: string
    name: string
}

export const germany: Country = {
    code: 'de',
    name: 'Deutschland',
}

export const countries: Country[] = [
    germany,
    {
        code: 'fr',
        name: 'Frankreich',
    },
]

export function fromCode(code: string): Country | null {
    return Nullable.fromPossiblyUndefined(
        countries.find(country => country.code === code))
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Country.ts